export default "__VITE_ASSET__CAHEsJrV__"